var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedbackError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4B3662F4-A6D0-4CD5-8255-E96F544D56BA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "staffNewBulk",
    transform: "translate(-993.000000, -354.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Banner-critical",
    transform: "translate(981.000000, 346.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(12.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Icon-BG",
    fill: "#FEAD9A",
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Fill",
    fill: "#FFFFFF",
    cx: 10,
    cy: 10,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,10 C2,8.154 2.635,6.457 3.688,5.103 L14.897,16.312 C13.542,17.365 11.846,18 10,18 C5.589,18 2,14.411 2,10 M16.312,14.897 L5.103,3.688 C6.458,2.635 8.154,2 10,2 C14.411,2 18,5.589 18,10 C18,11.846 17.365,13.543 16.312,14.897 M0,10 C0,15.514 4.486,20 10,20 C15.514,20 20,15.514 20,10 C20,4.486 15.514,0 10,0 C4.486,0 0,4.486 0,10",
    id: "Mask",
    fill: "#BF0711"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackError);
export default __webpack_public_path__ + "static/media/feedback-error.e7e3f827.svg";
export { ForwardRef as ReactComponent };